import { render, staticRenderFns } from "./ChatMassMessageSelector.vue?vue&type=template&id=4dec5b5d&"
import script from "./ChatMassMessageSelector.vue?vue&type=script&lang=js&"
export * from "./ChatMassMessageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports